import { render, staticRenderFns } from "./attributeSelector.vue?vue&type=template&id=63828a08"
import script from "./attributeSelector.vue?vue&type=script&lang=js"
export * from "./attributeSelector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports